"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _HookedNoteStore_instances, _HookedNoteStore_hooks, _HookedNoteStore_eventHooks, _HookedNoteStore_loading, _HookedNoteStore_storeSnapshot, _HookedNoteStore_needsSnapshot, _HookedNoteStore_nextNotifyTimer, _HookedNoteStore_updateSnapshot, _FlatNoteStore_events, _FlatNoteStore_ids, _KeyedReplaceableNoteStore_keyFn, _KeyedReplaceableNoteStore_events, _ReplaceableNoteStore_event;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteCollection = exports.ReplaceableNoteStore = exports.KeyedReplaceableNoteStore = exports.FlatNoteStore = exports.HookedNoteStore = exports.NoteStore = exports.EmptySnapshot = void 0;
const shared_1 = require("@snort/shared");
const utils_1 = require("./utils");
exports.EmptySnapshot = {
    data: undefined,
    clear: () => {
        // empty
    },
    loading: () => true,
    add: () => {
        // empty
    },
};
/**
 * Generic note store interface
 */
class NoteStore {
}
exports.NoteStore = NoteStore;
class HookedNoteStore {
    constructor() {
        _HookedNoteStore_instances.add(this);
        _HookedNoteStore_hooks.set(this, []);
        _HookedNoteStore_eventHooks.set(this, []);
        _HookedNoteStore_loading.set(this, true);
        _HookedNoteStore_storeSnapshot.set(this, {
            clear: () => this.clear(),
            loading: () => this.loading,
            add: ev => this.add(ev),
            data: undefined,
        });
        _HookedNoteStore_needsSnapshot.set(this, true);
        _HookedNoteStore_nextNotifyTimer.set(this, void 0);
    }
    get snapshot() {
        __classPrivateFieldGet(this, _HookedNoteStore_instances, "m", _HookedNoteStore_updateSnapshot).call(this);
        return __classPrivateFieldGet(this, _HookedNoteStore_storeSnapshot, "f");
    }
    get loading() {
        return __classPrivateFieldGet(this, _HookedNoteStore_loading, "f");
    }
    set loading(v) {
        __classPrivateFieldSet(this, _HookedNoteStore_loading, v, "f");
        this.onChange([]);
    }
    hook(cb) {
        __classPrivateFieldGet(this, _HookedNoteStore_hooks, "f").push(cb);
        return () => {
            const idx = __classPrivateFieldGet(this, _HookedNoteStore_hooks, "f").findIndex(a => a === cb);
            __classPrivateFieldGet(this, _HookedNoteStore_hooks, "f").splice(idx, 1);
        };
    }
    getSnapshotData() {
        __classPrivateFieldGet(this, _HookedNoteStore_instances, "m", _HookedNoteStore_updateSnapshot).call(this);
        return __classPrivateFieldGet(this, _HookedNoteStore_storeSnapshot, "f").data;
    }
    onEvent(cb) {
        const existing = __classPrivateFieldGet(this, _HookedNoteStore_eventHooks, "f").find(a => a === cb);
        if (!existing) {
            __classPrivateFieldGet(this, _HookedNoteStore_eventHooks, "f").push(cb);
            return () => {
                const idx = __classPrivateFieldGet(this, _HookedNoteStore_eventHooks, "f").findIndex(a => a === cb);
                __classPrivateFieldGet(this, _HookedNoteStore_eventHooks, "f").splice(idx, 1);
            };
        }
        return () => {
            //noop
        };
    }
    onChange(changes) {
        __classPrivateFieldSet(this, _HookedNoteStore_needsSnapshot, true, "f");
        if (!__classPrivateFieldGet(this, _HookedNoteStore_nextNotifyTimer, "f")) {
            __classPrivateFieldSet(this, _HookedNoteStore_nextNotifyTimer, setTimeout(() => {
                __classPrivateFieldSet(this, _HookedNoteStore_nextNotifyTimer, undefined, "f");
                for (const hk of __classPrivateFieldGet(this, _HookedNoteStore_hooks, "f")) {
                    hk();
                }
            }, 500), "f");
        }
        if (changes.length > 0) {
            for (const hkE of __classPrivateFieldGet(this, _HookedNoteStore_eventHooks, "f")) {
                hkE(changes);
            }
        }
    }
}
exports.HookedNoteStore = HookedNoteStore;
_HookedNoteStore_hooks = new WeakMap(), _HookedNoteStore_eventHooks = new WeakMap(), _HookedNoteStore_loading = new WeakMap(), _HookedNoteStore_storeSnapshot = new WeakMap(), _HookedNoteStore_needsSnapshot = new WeakMap(), _HookedNoteStore_nextNotifyTimer = new WeakMap(), _HookedNoteStore_instances = new WeakSet(), _HookedNoteStore_updateSnapshot = function _HookedNoteStore_updateSnapshot() {
    if (__classPrivateFieldGet(this, _HookedNoteStore_needsSnapshot, "f")) {
        __classPrivateFieldSet(this, _HookedNoteStore_storeSnapshot, {
            ...__classPrivateFieldGet(this, _HookedNoteStore_storeSnapshot, "f"),
            data: this.takeSnapshot(),
        }, "f");
        __classPrivateFieldSet(this, _HookedNoteStore_needsSnapshot, false, "f");
    }
};
/**
 * A simple flat container of events with no duplicates
 */
class FlatNoteStore extends HookedNoteStore {
    constructor() {
        super(...arguments);
        _FlatNoteStore_events.set(this, []);
        _FlatNoteStore_ids.set(this, new Set());
    }
    add(ev) {
        ev = Array.isArray(ev) ? ev : [ev];
        const changes = [];
        ev.forEach(a => {
            if (!__classPrivateFieldGet(this, _FlatNoteStore_ids, "f").has(a.id)) {
                __classPrivateFieldGet(this, _FlatNoteStore_events, "f").push(a);
                __classPrivateFieldGet(this, _FlatNoteStore_ids, "f").add(a.id);
                changes.push(a);
            }
            else {
                const existing = __classPrivateFieldGet(this, _FlatNoteStore_events, "f").find(b => b.id === a.id);
                if (existing) {
                    existing.relays = (0, shared_1.appendDedupe)(existing.relays, a.relays);
                }
            }
        });
        if (changes.length > 0) {
            this.onChange(changes);
        }
    }
    clear() {
        __classPrivateFieldSet(this, _FlatNoteStore_events, [], "f");
        __classPrivateFieldGet(this, _FlatNoteStore_ids, "f").clear();
        this.onChange([]);
    }
    takeSnapshot() {
        return [...__classPrivateFieldGet(this, _FlatNoteStore_events, "f")];
    }
}
exports.FlatNoteStore = FlatNoteStore;
_FlatNoteStore_events = new WeakMap(), _FlatNoteStore_ids = new WeakMap();
/**
 * A note store that holds a single replaceable event for a given user defined key generator function
 */
class KeyedReplaceableNoteStore extends HookedNoteStore {
    constructor(fn) {
        super();
        _KeyedReplaceableNoteStore_keyFn.set(this, void 0);
        _KeyedReplaceableNoteStore_events.set(this, new Map());
        __classPrivateFieldSet(this, _KeyedReplaceableNoteStore_keyFn, fn, "f");
    }
    add(ev) {
        ev = Array.isArray(ev) ? ev : [ev];
        const changes = [];
        ev.forEach(a => {
            const keyOnEvent = __classPrivateFieldGet(this, _KeyedReplaceableNoteStore_keyFn, "f").call(this, a);
            const existingCreated = __classPrivateFieldGet(this, _KeyedReplaceableNoteStore_events, "f").get(keyOnEvent)?.created_at ?? 0;
            if (a.created_at > existingCreated) {
                __classPrivateFieldGet(this, _KeyedReplaceableNoteStore_events, "f").set(keyOnEvent, a);
                changes.push(a);
            }
        });
        if (changes.length > 0) {
            this.onChange(changes);
        }
    }
    clear() {
        __classPrivateFieldGet(this, _KeyedReplaceableNoteStore_events, "f").clear();
        this.onChange([]);
    }
    takeSnapshot() {
        return [...__classPrivateFieldGet(this, _KeyedReplaceableNoteStore_events, "f").values()];
    }
}
exports.KeyedReplaceableNoteStore = KeyedReplaceableNoteStore;
_KeyedReplaceableNoteStore_keyFn = new WeakMap(), _KeyedReplaceableNoteStore_events = new WeakMap();
/**
 * A note store that holds a single replaceable event
 */
class ReplaceableNoteStore extends HookedNoteStore {
    constructor() {
        super(...arguments);
        _ReplaceableNoteStore_event.set(this, void 0);
    }
    add(ev) {
        ev = Array.isArray(ev) ? ev : [ev];
        const changes = [];
        ev.forEach(a => {
            const existingCreated = __classPrivateFieldGet(this, _ReplaceableNoteStore_event, "f")?.created_at ?? 0;
            if (a.created_at > existingCreated) {
                __classPrivateFieldSet(this, _ReplaceableNoteStore_event, a, "f");
                changes.push(a);
            }
        });
        if (changes.length > 0) {
            this.onChange(changes);
        }
    }
    clear() {
        __classPrivateFieldSet(this, _ReplaceableNoteStore_event, undefined, "f");
        this.onChange([]);
    }
    takeSnapshot() {
        if (__classPrivateFieldGet(this, _ReplaceableNoteStore_event, "f")) {
            return Object.freeze({ ...__classPrivateFieldGet(this, _ReplaceableNoteStore_event, "f") });
        }
    }
}
exports.ReplaceableNoteStore = ReplaceableNoteStore;
_ReplaceableNoteStore_event = new WeakMap();
/**
 * General use note store based on kind ranges
 */
class NoteCollection extends KeyedReplaceableNoteStore {
    constructor() {
        super(e => {
            const legacyReplaceable = [0, 3, 41];
            if (e.kind >= 30000 && e.kind < 40000) {
                return `${e.kind}:${e.pubkey}:${(0, utils_1.findTag)(e, "d")}`; // Parameterized replaceable
            }
            else if (e.kind >= 10000 && e.kind < 20000) {
                return `${e.kind}:${e.pubkey}`; // Replaceable event
            }
            else if (legacyReplaceable.includes(e.kind)) {
                return `${e.kind}:${e.pubkey}`; // Replaceable event
            }
            else {
                // Regular event
                // ephemeral events are like regular events
                // unknown kind
                return e.id;
            }
        });
    }
}
exports.NoteCollection = NoteCollection;
//# sourceMappingURL=data:application/json;base64,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